export default "__VITE_ASSET__BjxicJIx__"